export const GET_ALL_OBJECTS = "GET_ALL_OBJECTS";
export const RESET_DATA = "RESET_DATA";
export const START_LOADING_OBJECTS = "START_LOADING_OBJECTS";
export const STOP_LOADING_OBJECTS = "STOP_LOADING_OBJECTS";
export const ERROR_LOADING_OBJECTS = "ERROR_LOADING_OBJECTS";